import type { WorkbookPageWithProblems } from '@mathflat/domain/Workbook'
import { makeAutoObservable } from 'mobx'

export class WorkbookPageProblem {
  workbookProblem: WorkbookPageWithProblems['pageProblems'][number]['workbookProblem']
  exampleProblem: WorkbookPageWithProblems['pageProblems'][number]['exampleProblem'] // 예시 문항 정보
  originalProblem: WorkbookPageWithProblems['pageProblems'][number]['originalProblem'] // 원본 문항 정보

  constructor(data: WorkbookPageWithProblems['pageProblems'][number]) {
    this.exampleProblem = data.exampleProblem
    this.originalProblem = data.originalProblem
    this.workbookProblem = data.workbookProblem

    makeAutoObservable(this)
  }

  get id() {
    return this.workbookProblem.id
  }

  get workbookPageId() {
    return this.workbookProblem.workbookPageId
  }

  get number() {
    return this.workbookProblem.number
  }

  get problemId() {
    return this.workbookProblem.problemId
  }

  get title() {
    return this.workbookProblem.title
  }
}
